import { Badge } from "V2.0/common/badge";
import { delaySkipIfPastOutputPortsConfig } from "../../../Models/Delay";

export default DelayUntilTimestampSkipIfPast;

function DelayUntilTimestampSkipIfPast(props) {
  const { onSelect } = props;

  return (
    <div className="flex flex-col gap-y-4">
      {Object.values(delaySkipIfPastOutputPortsConfig).map((result, idx) => {
        return (
          <Badge
            color={result.color}
            key={result.outputPort}
            className="hover:cursor-pointer"
            onClick={() => onSelect(result)}
          >
            {result.label}
          </Badge>
        );
      })}
    </div>
  );
}
